import React from 'react';
import PropTypes from 'prop-types';

import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * CsvButton — the "⬇ CSV" download button shared by ChartCard's list view and DataTable.
 * The caller supplies the already-computed aphrodite class (via css(styles.csvBtn)) so the
 * rendered markup stays byte-identical to the original inline buttons.
 */
export default function CsvButton({ className, onClick, title }) {
  return (
    <button type="button" className={className} onClick={onClick} title={title}>
      <FontAwesomeIcon icon={faDownload} />
      CSV
    </button>
  );
}
CsvButton.propTypes = {
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
};
CsvButton.defaultProps = { title: null };
